import React from 'react';
import SectionIcon from '@/components/SectionIcon';
import { I } from '@/lib/icons';

export default function EmptyState({ icon = 'doc', color = 'gray', title, desc, ctaLabel, onCta, secondaryCtaLabel, onSecondaryCta }) {
  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      textAlign: 'center', padding: '52px 32px',
      background: 'var(--bg-surface)', border: '1px dashed var(--border-strong)',
      borderRadius: 'var(--r-lg)',
    }}>
      <SectionIcon color={color} size={56}>
        {React.createElement(I[icon] || I.doc, { width: 26, height: 26 })}
      </SectionIcon>
      <div style={{ fontSize: 16, fontWeight: 700, marginTop: 14, marginBottom: 4 }}>{title}</div>
      <div style={{
        fontSize: 13, color: 'var(--text-muted)', maxWidth: 360,
        lineHeight: 1.55, marginBottom: 18,
      }}>{desc}</div>
      <div style={{ display: 'flex', gap: 8 }}>
        {ctaLabel && (
          <button onClick={onCta} className="cd-btn cd-btn-primary">
            <I.plus /> {ctaLabel}
          </button>
        )}
        {secondaryCtaLabel && (
          <button onClick={onSecondaryCta} className="cd-btn cd-btn-secondary">
            {secondaryCtaLabel}
          </button>
        )}
      </div>
    </div>
  );
}
